import React from "react";
import InstallmentCalculator from "./InstallmentCalculator";

function LeasingInstallmentCalculator(props) {

    const calculationEndPoints = {
        calculatorUrl: "/operational-leasing/calculation",
        allowedCalculationParametersUrl: "/operational-leasing/allowed-calculation-parameters/?priceNet="
            + props.offer.minimumPriceNet
    }

    const visibleInsuranceOptions = {
        ocAcInsurance12MonthsVisible: props.offer.hasReturnGuarantee,
        ocAcInsuranceAllMonthsVisible: props.offer.hasReturnGuarantee,
        gapInsuranceVisible: true
    }

    return (
        <InstallmentCalculator
            {...props}
            {...calculationEndPoints}
            {...visibleInsuranceOptions}
        />
    );
}

export default LeasingInstallmentCalculator;